export default "__VITE_ASSET__81890d3a__"